import { CHART_COLOR_PALLETTE } from 'utils/constants';
import { ICellRendererParams, ICurrencyFormat } from 'utils/types';
import {
  cellCurrencyRendererFramework,
  cellNumberRendererFramework,
  varianceCurrencyCellRendererFramework,
  varianceNumberCellRendererFramework,
} from '../TableComponents';

const DEFAULT_COLUMN_WIDTH = 160;
const TITLE_COLUMN_WIDTH = 208;
const SMALL_COLUMN_WIDTH = 88;
const WIDTH_SHORTEN = 16;

const groupedColumnCellStyles = {
  'padding-right': 0,
  'justify-content': 'flex-end',
};

export const getColumnDefs = ({
  columnDateLabels,
  format,
  isHeadcount,
  permanentContractorChecked,
}: {
  columnDateLabels: string[];
  format: ICurrencyFormat;
  isHeadcount: boolean;
  permanentContractorChecked?: boolean;
}) => {
  const titleWidth = permanentContractorChecked
    ? TITLE_COLUMN_WIDTH - WIDTH_SHORTEN
    : TITLE_COLUMN_WIDTH;
  const defaultWidth = permanentContractorChecked
    ? DEFAULT_COLUMN_WIDTH - WIDTH_SHORTEN
    : DEFAULT_COLUMN_WIDTH;
  const smallWidth = permanentContractorChecked
    ? SMALL_COLUMN_WIDTH - WIDTH_SHORTEN
    : SMALL_COLUMN_WIDTH;
  const totalColumns = {
    headerName: 'TOTAL',
    headerGroupComponent: 'customHeaderGroupComponent',
    children: [
      {
        headerName: columnDateLabels[0],
        field: 'totalCurrYear',
        width: smallWidth,
        headerComponentParams: {
          color: CHART_COLOR_PALLETTE[0],
          align: 'right',
        },
        sortable: true,
        cellStyle: groupedColumnCellStyles,
        cellRendererFramework: (params: ICellRendererParams) =>
          isHeadcount
            ? cellNumberRendererFramework(params, format)
            : cellCurrencyRendererFramework(params, format),
      },
      {
        headerName: columnDateLabels[1],
        field: 'totalPrevYear',
        width: smallWidth,
        headerComponentParams: {
          color: CHART_COLOR_PALLETTE[1],
          align: 'right',
        },
        sortable: true,
        cellStyle: groupedColumnCellStyles,
        cellRendererFramework: (params: ICellRendererParams) =>
          isHeadcount
            ? cellNumberRendererFramework(params, format)
            : cellCurrencyRendererFramework(params, format),
      },
      {
        headerName: 'CHANGE',
        field: 'totalChange',
        width: smallWidth + WIDTH_SHORTEN,
        headerComponentParams: {
          align: 'right',
        },
        sortable: true,
        cellStyle: groupedColumnCellStyles,
        cellRendererFramework: (params: ICellRendererParams) =>
          isHeadcount
            ? varianceNumberCellRendererFramework(params, format)
            : varianceCurrencyCellRendererFramework(params, format),
      },
    ],
  };
  const descriptionColumns = [
    {
      headerName: 'Job role',
      field: 'title',
      tooltipField: 'title',
      width: titleWidth,
      headerComponentParams: { hideIcon: true },
      sortable: true,
    },
    {
      headerName: 'service tower',
      field: 'serviceTower',
      tooltipField: 'serviceTower',
      width: defaultWidth,
      headerComponentParams: { hideIcon: true, test: true },
      sortable: true,
    },
    {
      headerName: 'Business unit',
      field: 'businessUnit',
      tooltipField: 'businessUnit',
      width: defaultWidth,
      headerComponentParams: { hideIcon: true },
      sortable: true,
    },
    {
      headerName: 'Location',
      field: 'location',
      tooltipField: 'location',
      width: defaultWidth,
      headerComponentParams: { hideIcon: true },
    },
    {
      headerName: 'EXPENSE TYPE',
      field: 'expenseType',
      tooltipField: 'expenseType',
      width: 104,
      sortable: true,
      headerComponentParams: { hideIcon: true },
    },
  ];
  if (permanentContractorChecked) {
    return [
      ...descriptionColumns,
      {
        headerName: 'Perm',
        field: 'permanentCount',
        tooltipField: 'permanentCount',
        width: 54,
        sortable: true,
        headerComponentParams: { hideIcon: true },
      },
      {
        headerName: 'Contr',
        field: 'contractorCount',
        tooltipField: 'contractorCount',
        width: 54,
        sortable: true,
        headerComponentParams: { hideIcon: true },
      },
      totalColumns,
    ];
  }
  return [...descriptionColumns, totalColumns];
};

export const getTableData = ({
  columnDateLabels,
  format,
  isHeadcount,
  permanentContractorChecked,
}: {
  columnDateLabels: string[];
  format: ICurrencyFormat;
  isHeadcount: boolean;
  permanentContractorChecked?: boolean;
}) => {
  return {
    columnDefs: getColumnDefs({
      columnDateLabels,
      format,
      isHeadcount,
      permanentContractorChecked,
    }),
  };
};
